function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#86A8FC",
  d: "M765.9,981.3H72.6c-17.5,0-31.8-14.2-31.8-31.8V74.2c0-17.5,14.2-31.8,31.8-31.8h510.7l214.3,206.3v700.8 C797.7,967.1,783.5,981.3,765.9,981.3z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M581.3,86.9v156.8c0,4.7,3.8,8.6,8.6,8.6h161.8L581.3,86.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M702.3,784.6l-566-0.4c-3.3,0-6-2.7-6-6l0-30.5c0-3.3,2.7-6,6-6l566,0.4c3.3,0,6,2.7,6,6l0,30.5 C708.3,781.9,705.6,784.6,702.3,784.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M525.8,876.3L136.2,876c-3.3,0-6-2.7-6-6l0-30.5c0-3.3,2.7-6,6-6l389.6,0.3c3.3,0,6,2.7,6,6l0,30.5 C531.8,873.6,529.1,876.3,525.8,876.3z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4667ED",
  d: "M357.4,609.9l-95.7-91.6c-2.8-2.7-2.9-7.2-0.2-10.1l23-24c2.7-2.8,7.2-2.9,10.1-0.2l62.3,59.7 c2.8,2.7,7.2,2.6,9.9-0.1l176.8-174.5c2.8-2.8,7.3-2.7,10.1,0.1l23.3,23.6c2.8,2.8,2.7,7.3-0.1,10.1L367.3,609.8 C364.5,612.5,360.1,612.6,357.4,609.9z"
}));

const SvgConfirmationIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 840 1024",
    style: {
      enableBackground: "new 0 0 840 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConfirmationIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/confirmation-icon.e43eb42f.svg";
export { ForwardRef as ReactComponent };